import { animeList } from "@/mocks/anime";
import SectionHeading from "./SectionHeading";

export default function Review() {
  const ranked = [...animeList].sort((a, b) => b.score - a.score).slice(0, 8);
  const max = ranked[0].score;

  return (
    <section id="review" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-5 lg:gap-12">
          <div className="lg:col-span-2">
            <SectionHeading
              eyebrow="口碑排行"
              title="观众用脚投票的口碑之王"
              desc="不看营销不看热度，只看真实观众的完播率与长期口碑。这份排行会说话——能上榜的，都是被反复提起、值得一刷再刷的好番。"
            />
            <div className="rounded-lg border border-primary-100 bg-primary-50 p-5 md:p-6">
              <span className="inline-flex items-center gap-1.5 text-sm font-bold text-primary-700">
                <i className="ri-vip-crown-2-fill" />
                小虎的口碑怎么看
              </span>
              <p className="mt-3 text-sm leading-6 text-primary-900/80">
                我们更看重"看完的人怎么说"，而不是"点开的人有多少"。完播率、长评率、二次观看率，都算进这份口碑分里。
              </p>
            </div>
          </div>

          <div className="lg:col-span-3">
            <ul className="space-y-4">
              {ranked.map((item, i) => (
                <li key={item.id}>
                  <div className="flex items-center gap-3 rounded-lg border border-background-200 bg-background-100 p-3 md:gap-4 md:p-4">
                    <span className={`inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full font-heading ${i < 3 ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-600'}`}>
                      {i + 1}
                    </span>
                    <div className="h-14 w-12 shrink-0 overflow-hidden rounded-md bg-background-200 md:h-16 md:w-14">
                      <img
                        src={item.image}
                        alt={`口碑排行第${i + 1}名：${item.title}`}
                        title={`${item.title} - 小虎看番口碑排行`}
                        className="h-full w-full object-cover object-top"
                      />
                    </div>
                    <div className="min-w-0 flex-1">
                      <div className="flex items-center justify-between gap-2">
                        <h4 className="truncate font-heading text-base text-foreground-950">{item.title}</h4>
                        <span className="shrink-0 text-sm font-bold text-primary-600">{item.score.toFixed(1)}</span>
                      </div>
                      <div className="mt-2 h-2 w-full overflow-hidden rounded-full bg-background-200">
                        <div
                          className="h-full rounded-full bg-accent-500"
                          style={{ width: `${(item.score / max) * 100}%` }}
                        />
                      </div>
                      <div className="mt-1.5 flex flex-wrap gap-2 text-xs text-foreground-500">
                        {item.tags.map((t) => (
                          <span key={t}>{t}</span>
                        ))}
                      </div>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}